import StartupTNPage from './StartupTNPage';
export default StartupTNPage;
